export default "__VITE_ASSET__DSlhtFGt__"